var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-logo"},[_c('img',{attrs:{"src":require('@/../images/loading/coolsis.png'),"alt":"加載中..."}})])])}
var staticRenderFns = []

export { render, staticRenderFns }